import {GetSafeValue} from '../utils/get-safe-value';
import {StringFieldUtil} from '../utils/string-field-util';
import {StringUtils} from "../utils/string-utils";
import {ItemVariation} from "../inventory/model/item";

export class DeliverySetting {

 private _country: string;
 private _city: string;
 private _nextDayCost: number;
 private _sameDayCost: number;
 private _limitCostFreeShipping: number;
 private _customDayShipping: number;
 private _customDayCost: number;

 fromJson(data: DeliverySetting){
   this.country = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.country], null);
   this.city = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.city], null);
   this.sameDayCost = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.sameDayCost], 0);
   this.nextDayCost = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.nextDayCost], 0);
   this.limitCostFreeShipping = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.limitCostFreeShipping], null);
   this.customDayCost = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.customDayCost], 0);
   this.customDayShipping = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.customDayShipping], 0);
 }

 clone(data: DeliverySetting){
   this.country = data.country;
   this.city = data.city;
   this.sameDayCost = data.sameDayCost;
   this.nextDayCost = data.nextDayCost;
   this.limitCostFreeShipping = data.limitCostFreeShipping;
   this.customDayCost = data.customDayCost;
   this.customDayShipping = data.customDayShipping;
 }

  get customDayShipping(): number {
    return this._customDayShipping;
  }

  set customDayShipping(value: number) {
    this._customDayShipping = value;
  }

  get customDayCost(): number {
    return this._customDayCost;
  }

  set customDayCost(value: number) {
    this._customDayCost = value;
  }

  get limitCostFreeShipping(): number {
    return this._limitCostFreeShipping;
  }

  set limitCostFreeShipping(value: number) {
    this._limitCostFreeShipping = value;
  }

  get country(): string {
    return this._country;
  }

  set country(value: string) {
    this._country = value;
  }

  get city(): string {
    return this._city;
  }

  set city(value: string) {
    this._city = value;
  }

  get nextDayCost(): number {
    return this._nextDayCost;
  }

  set nextDayCost(value: number) {
    this._nextDayCost = value;
  }

  get sameDayCost(): number {
    return this._sameDayCost;
  }

  set sameDayCost(value: number) {
    this._sameDayCost = value;
  }

  toMap() {
    return {
      'country': this.country,
      'city': this.city,
      'sameDayCost': this.sameDayCost,
      'nextDayCost': this.nextDayCost,
      'limitCostFreeShipping': this.limitCostFreeShipping,
      'customDayCost': this.customDayCost,
      'customDayShipping': this.customDayShipping,
    }
  }
}

export class GeneralSettings {
  private _baseLocation: Map<string, string>;
  private _deliveryRoute: string[];
  private _sameRegionDeliveryRate: number;
  private _limitCostFreeShipping: number;
  private _maxSameRegionDeliveryDistance: number;
  private _maxSameRegionDeliveryCost: number;
  private _minSameRegionDeliveryCost: number;

  constructor() {
    this.baseLocation = new Map();
    this.deliveryRoute = [];
  }

  get baseLocation(): Map<string, string> {
    return this._baseLocation;
  }

  set baseLocation(value: Map<string, string>) {
    this._baseLocation = value;
  }

  get deliveryRoute(): string[] {
    return this._deliveryRoute;
  }

  set deliveryRoute(value: string[]) {
    this._deliveryRoute = value;
  }

  get sameRegionDeliveryRate(): number {
    return this._sameRegionDeliveryRate;
  }

  set sameRegionDeliveryRate(value: number) {
    this._sameRegionDeliveryRate = value;
  }

  get limitCostFreeShipping(): number {
    return this._limitCostFreeShipping;
  }

  set limitCostFreeShipping(value: number) {
    this._limitCostFreeShipping = value;
  }

  get maxSameRegionDeliveryDistance(): number {
    return this._maxSameRegionDeliveryDistance;
  }

  set maxSameRegionDeliveryDistance(value: number) {
    this._maxSameRegionDeliveryDistance = value;
  }

  get maxSameRegionDeliveryCost(): number {
    return this._maxSameRegionDeliveryCost;
  }

  set maxSameRegionDeliveryCost(value: number) {
    this._maxSameRegionDeliveryCost = value;
  }

  get minSameRegionDeliveryCost(): number {
    return this._minSameRegionDeliveryCost;
  }

  set minSameRegionDeliveryCost(value: number) {
    this._minSameRegionDeliveryCost = value;
  }

  clone(data: GeneralSettings){
    this.baseLocation = data.baseLocation;
    this.deliveryRoute = data.deliveryRoute;
    this.sameRegionDeliveryRate = data.sameRegionDeliveryRate;
    this.limitCostFreeShipping = data.limitCostFreeShipping;
    this.maxSameRegionDeliveryDistance = data.maxSameRegionDeliveryDistance;
    this.maxSameRegionDeliveryCost = data.maxSameRegionDeliveryCost;
    this.minSameRegionDeliveryCost = data.minSameRegionDeliveryCost;
  }

  fromJson(data: GeneralSettings){
    this.baseLocation = StringUtils.objToStrMap(GetSafeValue.getSafeValueAsMap(
      data[StringFieldUtil.baseLocation],
      {'lat': "", 'lon': ""}
    ));
    this.deliveryRoute = GetSafeValue.getSafeValueAsList(data[StringFieldUtil.deliveryRoute], [], []);
    this.sameRegionDeliveryRate = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.sameRegionDeliveryRate], 0);
    this.limitCostFreeShipping = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.limitCostFreeShipping], 0);
    this.maxSameRegionDeliveryDistance = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.maxSameRegionDeliveryDistance], 0);
    this.maxSameRegionDeliveryCost = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.maxSameRegionDeliveryCost], 0);
    this.minSameRegionDeliveryCost = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.minSameRegionDeliveryCost], 0);

  }

  toMap(){
    return {
      "baseLocation": {
        'lat': this.deliveryRoute['lat'],
        'lon': this.deliveryRoute['lon']
      },
      "deliveryRoute": this.deliveryRoute,
      "sameRegionDeliveryRate": this.sameRegionDeliveryRate,
      "limitCostFreeShipping": this.limitCostFreeShipping,
      "maxSameRegionDeliveryDistance": this.maxSameRegionDeliveryDistance,
      "maxSameRegionDeliveryCost": this.maxSameRegionDeliveryCost,
      "minSameRegionDeliveryCost": this.minSameRegionDeliveryCost
    }
  }

  toMapByStore(){
    return {
      "sameRegionDeliveryRate": this.sameRegionDeliveryRate || 0,
      "limitCostFreeShipping": this.limitCostFreeShipping || 0,
      "maxSameRegionDeliveryDistance": this.maxSameRegionDeliveryDistance || 0,
      "maxSameRegionDeliveryCost": this.maxSameRegionDeliveryCost || 0,
      "minSameRegionDeliveryCost": this.minSameRegionDeliveryCost || 0
    }
  }
}

export class OptionsDelivery {
  private _days: number;
  private _message: Map<string, string>;
  private _name: Map<string, string>;
  private _value: number;
  private _limitCostFreeShipping: number;


  constructor() {
    this.message = new Map();
    this.name = new Map();
    this.value = 0;
    this.days = 0;
    this.limitCostFreeShipping = 0;
  }

  get value(): number {
    return this._value;
  }

  set value(value: number) {
    this._value = value;
  }

  get days(): number {
    return this._days;
  }

  set days(value: number) {
    this._days = value;
  }

  get message(): Map<string, string> {
    return this._message;
  }

  set message(value: Map<string, string>) {
    this._message = value;
  }

  get name(): Map<string, string> {
    return this._name;
  }

  set name(value: Map<string, string>) {
    this._name = value;
  }


  get limitCostFreeShipping(): number {
    return this._limitCostFreeShipping;
  }

  set limitCostFreeShipping(value: number) {
    this._limitCostFreeShipping = value;
  }

  clone(data: OptionsDelivery){
    this.days = data.days;
    this.message = data.message;
    this.name = data.name;
    this.value = data.value;
    this.limitCostFreeShipping = data.limitCostFreeShipping;
  }

  fromJson(data: any){
    this.message = StringUtils.objToStrMap(GetSafeValue.getSafeValueAsMap(
      data[StringFieldUtil.message],
      {'en': "", 'kh': ""}
    ));
    this.name = StringUtils.objToStrMap(GetSafeValue.getSafeValueAsMap(
      data[StringFieldUtil.name_],
      {'en': "", 'kh': ""}
    ));
    this.days = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.days], null);
    this.value = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.value], null);
    this.limitCostFreeShipping = GetSafeValue.getSafeValueAsNumber(data[StringFieldUtil.limitCostFreeShipping], 0);
  }

  toMap(){
    return {
      "message": {
        'en': this.message.get('en') || null,
        'kh': this.message.get('kh') || null
      },
      "name": {
        'en': this.name.get('en') || null,
        'kh': this.name.get('kh') || null
      },
      "days": this.days || null,
      "value": this.value || null,
      "limitCostFreeShipping": this.limitCostFreeShipping || null,
    }
  }
}

export class RegionsDelivery {
  private _country: string;
  private _city: string;
  private _optionsDelivery: Map<string, OptionsDelivery>;


  constructor() {
    this.optionsDelivery = new Map();
  }

  get country(): string {
    return this._country;
  }

  set country(value: string) {
    this._country = value;
  }

  get city(): string {
    return this._city;
  }

  set city(value: string) {
    this._city = value;
  }

  get optionsDelivery(): Map<string, OptionsDelivery> {
    return this._optionsDelivery;
  }

  set optionsDelivery(value: Map<string, OptionsDelivery>) {
    this._optionsDelivery = value;
  }

  clone(data: RegionsDelivery){
    this.city = data.city;
    this.country = data.country;
    this.optionsDelivery = new Map(data.optionsDelivery);
  }

  fromJson(data: any){
    this.city = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.city], null);
    this.country = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.country], null);

    if(data[StringFieldUtil.options]){
      StringUtils.objToStrMap(data[StringFieldUtil.options]).forEach((v, k) => {
        let optionsDelivery = new OptionsDelivery();
        optionsDelivery.fromJson(v);
        this.optionsDelivery.set(k, optionsDelivery);
      });
    }
  }

  toMap(){
    const optionsDeliveryMap = new Map();
    this.optionsDelivery.forEach(((value, key) => {
        optionsDeliveryMap.set(key, value.toMap());
      }
    ));

    return {
      "city": this.city || null,
      "country": this.country || null,
      "options": optionsDeliveryMap ? StringUtils.strMapToObj(optionsDeliveryMap) : null
    }
  }


}

export class DeliverySettingService {
  private _generalSettings: GeneralSettings;
  private _regionsDelivery: RegionsDelivery[];
  private _optionsDelivery: Map<string, OptionsDelivery>;

  constructor() {
    this.regionsDelivery = [];
    this.optionsDelivery = new Map();
    this.generalSettings = new GeneralSettings();
  }

  get generalSettings(): GeneralSettings {
    return this._generalSettings;
  }

  set generalSettings(value: GeneralSettings) {
    this._generalSettings = value;
  }

  get regionsDelivery(): RegionsDelivery[] {
    return this._regionsDelivery;
  }

  set regionsDelivery(value: RegionsDelivery[]) {
    this._regionsDelivery = value;
  }

  get optionsDelivery(): Map<string, OptionsDelivery> {
    return this._optionsDelivery;
  }

  set optionsDelivery(value: Map<string, OptionsDelivery>) {
    this._optionsDelivery = value;
  }

  clone(data : DeliverySettingService){
    this.generalSettings = new GeneralSettings();
    this.generalSettings.clone(data.generalSettings);
    this.optionsDelivery = data.optionsDelivery;

    data.regionsDelivery.forEach((value)=>{
      let regionsDelivery = new RegionsDelivery();
      regionsDelivery.clone(value);
      this.regionsDelivery.push(regionsDelivery);
    });
  }

  fromJson(data: DeliverySettingService){
    if(data[StringFieldUtil.generalSettings]){
      let generalSettings = new GeneralSettings();
      generalSettings.fromJson(data[StringFieldUtil.generalSettings]);
      this.generalSettings = generalSettings;
    }

    if(data[StringFieldUtil.regions]){
      StringUtils.objToStrMap(data[StringFieldUtil.regions]).forEach((v, k) => {
        let regionsDelivery = new RegionsDelivery();
        regionsDelivery.fromJson(v);
        this.regionsDelivery.push(regionsDelivery);
      });
    }

    if(data['regionsDelivery']){
      StringUtils.objToStrMap(data['regionsDelivery']).forEach((v, k) => {
        let regionsDelivery = new RegionsDelivery();
        regionsDelivery.fromJson(v);
        this.regionsDelivery.push(regionsDelivery);
      });
    }

    if(data[StringFieldUtil.options]){
      StringUtils.objToStrMap(data[StringFieldUtil.options]).forEach((v, k) => {
        let optionsDelivery = new OptionsDelivery();
        optionsDelivery.fromJson(v);
        this.optionsDelivery.set(k, optionsDelivery);
      });
    }

  }

  toMap(){
    const regionsDelivery = [];
    this.regionsDelivery.forEach((value => {
        regionsDelivery.push(value.toMap())
      }
    ));

    return {
      "generalSettings": this.generalSettings.toMap(),
      "options": StringUtils.strMapToObj(this.optionsDelivery),
      "regions": regionsDelivery ? regionsDelivery : null
    }
  }

  toMapByStore(){
    const regionsDelivery = [];
    this.regionsDelivery.forEach((value => {
        regionsDelivery.push(value.toMap())
      }
    ));

    return {
      "generalSettings": this.generalSettings.toMapByStore(),
      "regions": regionsDelivery ? regionsDelivery : null
    }
  }

}
